<template>
  <div class="dash-attempt">
    <div class="dash-attempt__badge">
      <div class="dash-attempt__badge-space">
        <jade-badge
          variant="text"
          :voice="color"
        >
          {{ textBadge }}
        </jade-badge>
      </div>
      <span
        data-testid="test-line"
        class="dash-attempt__badge-line"
        :class="{ 'dash-attempt__badge-line-first': firstItem }"
      ></span>
    </div>
    <jade-list-item
      navigation
      :label="label"
      :description="description"
      :thirdLine="thirdLine"
      :variant="computedVariant"
      @onClick="clickAttempt"
    >
      <template #trailing>
        <jade-text
          data-testid="test-trailing"
          color="medium"
          variant="text-medium"
          weight="medium"
        >
          {{ trailingText }}
        </jade-text>
      </template>
    </jade-list-item>
  </div>
</template>

<script>
import JadeListItem from '@jade/JadeListItem/index.vue'
import JadeText from '@jade/JadeText/index.vue'
import JadeBadge from '@jade/JadeBadge/index.vue'
import sendEvent from '@utils/analiticaEventCaller.utils'

const VARIANT_LIST_ITEM = {
  DANGER: 'danger',
  PRIMARY: 'primary'
}

const COLORS_BADGE = {
  INFO: 'info',
  NEGATIVE: 'negative',
  WARNING: 'warning',
  POSITIVE: 'positive',
  BRAND: 'brand'
}

export default {
  name: 'DashAttempt',
  components: {
    JadeListItem,
    JadeText,
    JadeBadge
  },
  props: {
    firstItem: Boolean,
    description: String,
    thirdLine: String,
    trailingText: String,
    textBadge: String,
    attemptId: [Number, String],
    label: {
      type: String,
      required: true
    },
    color: {
      type: String,
      validation: color => Object.values(COLORS_BADGE).includes(color),
      default: COLORS_BADGE.INFO
    },
    eventProps: {
      type: Object,
      required: false
    }
  },
  computed: {
    computedVariant () {
      return this.color === COLORS_BADGE.NEGATIVE
        ? VARIANT_LIST_ITEM.DANGER
        : VARIANT_LIST_ITEM.PRIMARY
    }
  },
  methods: {
    clickAttempt () {
      this.eventCaller()
      if (!this.attemptId) throw new Error('Missing attemptId')
      this.$emit('handleClick', this.attemptId)
    },
    eventCaller () {
      if (
        !this.eventProps?.amplitudeInstance ||
        !this.eventProps?.eventFunctionName
      )
        return

      sendEvent({
        instanceName: this.eventProps.amplitudeInstance,
        featureName: 'actions',
        functionName: this.eventProps.eventFunctionName
      })
    }
  }
}
</script>

<style scoped>
.dash-attempt {
  display: flex;
}
.dash-attempt__badge {
  position: relative;
  z-index: 1;
  width: 38px;
  display: flex;
  justify-content: center;
}
.dash-attempt__badge-space {
  margin-top: var(--global-space-150, 12px);
  padding-left: var(--global-space-50, 4px);
  padding-right: var(--global-space-50, 4px);
}
.dash-attempt__badge-line {
  border: 1px solid var(--global-color-slate-7, #02173519);
  height: 100%;
  position: absolute;
  left: 50%;
  margin-left: -1px;
  top: 0;
  z-index: -1;
}
.dash-attempt__badge-line-first {
  margin-top: var(--global-space-200, 16px);
  height: calc(100% - 12px);
}
</style>
